export default "/assets/website/images/chevron-back.svg?9ff7ca987cff76255844c0ba03bb55f3";